export class FaceBookConversion {
  customerGuid: string;
  userAgent: string;
  url: string;
  fbc: string;
  fbp: string;
  conversionType: string;
  conversionData: any;
}


export class FaceBookProduct {
  content_type = 'product';
  content_name: string;
  content_ids: string[];
  contents: FaceBookContents[];
  currency: string;
  value: number
}

export class FaceBookProductView {
  content_type = 'product';
  content_name: string;
  content_category: string;
  contents: FaceBookContents[];
  currency: string;
  value: number
}

export class FaceBookPayment {
  content_category = 'checkout';
  content_ids: string[];
  contents: FaceBookContents[];
  currency: string;
  value: number
}

export class FaceBookCheckout {
  content_category = 'checkout';
  content_ids: string[];
  contents: FaceBookContents[];
  currency: string;
  num_items: number;
  value: number;
}

export class FaceBookPurchase {
  content_name = 'checkout_complete';
  content_type = 'product';
  contents: FaceBookContents[];
  currency: string;
  num_items: number;
  value: number;
}

export class FaceBookContents {
  id: string;
  quantity: number;
}

